import { render, staticRenderFns } from "./Zhuanta.vue?vue&type=template&id=4c600b4e&"
import script from "./Zhuanta.vue?vue&type=script&lang=js&"
export * from "./Zhuanta.vue?vue&type=script&lang=js&"
import style0 from "./Zhuanta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports